import React from 'react'
import Tooltip from "@material-ui/core/Tooltip"
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt'
import KingBedIcon from '@material-ui/icons/KingBed'
import DataField from "../../../utils/DataField"
import {getCustomSection, getCustomValue, formatCustomDate, formatCount} from "../customDataUtils"



function StayDate(props) {

    if (props.label == null) return null

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: "1", textAlign: "center"}}>
            <span className={["labelText", "normalSmallSize", "bold", "noWrap"].join(" ")}>
                {props.title}
            </span>
            <span className={["normalText", "subtitleSize", "bold", "noWrap"].join(" ")}>
                {props.label}
            </span>
        </div>
    )
}



function ReservationDetailsCard(props) {

    let reservation_details = getCustomSection(props.custom_data, "reservation_details")

    if (reservation_details == null) return null

    let checkinDate = formatCustomDate(getCustomValue(reservation_details, "checkin_date"))
    let checkoutDate = formatCustomDate(getCustomValue(reservation_details, "checkout_date"))
    let roomNights = formatCount(getCustomValue(reservation_details, "room_nights"), "diária", "diárias")
    let numberOfRooms = formatCount(getCustomValue(reservation_details, "number_of_rooms"), "quarto", "quartos")

    let fields = [
        {title: "Modelo de Negócio", label: getCustomValue(reservation_details, "business_model")},
        {title: "Segmento", label: getCustomValue(reservation_details, "segment")},
        {title: "Canal", label: getCustomValue(reservation_details, "channel_name")},
        {title: "Antecedência", label: formatCount(getCustomValue(reservation_details, "lead_time_days"), "dia", "dias")},
        {title: "Identificador da Reserva", label: getCustomValue(reservation_details, "booking_id")}
    ].filter(field => field.label != null)

    let showStayArrow = checkinDate != null && checkoutDate != null
    let showStayPeriod = checkinDate != null || checkoutDate != null || roomNights != null

    if (!showStayPeriod && numberOfRooms == null && fields.length === 0) return null

    return (
        <div className="analysisCard">
            <div className={["blueText", "normalMediumSize", "bold"].join(" ")}>
                DETALHES DA RESERVA
            </div>
            {showStayPeriod ?
            <div
                className="internalCardContainer"
                style={{display: "flex", alignItems: "center", justifyContent: "center", background: "#F7F7F7", borderRadius: "10px", padding: "15px 20px"}}
            >
                <StayDate title={"CHECK-IN"} label={checkinDate}/>
                {showStayArrow || roomNights != null ?
                <div style={{display: "flex", flexDirection: "column", alignItems: "center", padding: "0px 15px"}}>
                    {showStayArrow ? <ArrowRightAltIcon style={{color: "#0b1f82"}}/> : null}
                    {roomNights == null ? null :
                    <span className={["labelText", "normalSmallSize", "noWrap"].join(" ")}>
                        {roomNights}
                    </span>}
                </div> : null}
                <StayDate title={"CHECK-OUT"} label={checkoutDate}/>
            </div> : null}
            {numberOfRooms == null ? null :
            <div className="smallerInternalCardContainer" style={{display: "flex", alignItems: "center"}}>
                <Tooltip title={<p className="tooltipText">Quartos</p>}>
                    <KingBedIcon style={{width: "22px", height: "22px", color: "#0b1f82"}}/>
                </Tooltip>
                <span className={["labelText", "normalMediumSize", "labelSpace"].join(" ")}>
                    {numberOfRooms}
                </span>
            </div>}
            {fields.length === 0 ? null :
            <div className="smallerInternalCardContainer" style={{display: "flex", flexWrap: "wrap"}}>
                {fields.map((field, index) => (
                    <div key={index} style={{width: "50%"}}>
                        <DataField
                            title={field.title}
                            label={field.label}
                            size={"normalMediumSize"}
                            titleNoWrap={true}
                            margin="5px"
                            display={"inline"}
                            labelStyles={{wordBreak: "break-all"}}
                        />
                    </div>
                ))}
            </div>}
        </div>
    )
}



export default ReservationDetailsCard
